import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/response.model';

@Injectable({
    providedIn:'root'
})
export class SchSuscriptorService{
    private url:string;

    constructor(private http:HttpClient){
        this.url=environment.api;
    }
    public create(customerId:number,file: File):Observable<ResponseModel>{
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<ResponseModel>(this.url+'schSuscriptor/create/'+customerId,formData);
    }
    public list():Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/json');

        return this.http.get<ResponseModel>(this.url+'schSuscriptor/list',{headers:headers});
    }
}